interface ConfirmationModalProps {
  timer: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmationModal({ timer, onConfirm, onCancel }: ConfirmationModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 backdrop-blur-sm" data-testid="confirmation-modal-overlay">
      <div className="bg-background-paper rounded-lg p-6 max-w-md w-full shadow-xl text-foreground" data-testid="confirmation-modal-container">
        <h3 className="text-lg font-semibold mb-4" data-testid="confirmation-modal-title">Confirm Your Booking</h3>
        <p className="mb-4 text-foreground-muted" data-testid="confirmation-modal-message">Your ride will be confirmed in <span data-testid="confirmation-modal-timer">{timer}</span> seconds. Would you like to proceed?</p>
        <div className="flex space-x-4">
          <button
            onClick={onConfirm}
            className="flex-1 bg-primary text-primary-foreground py-2 rounded-lg hover:bg-primary/90 transition-colors"
            data-testid="confirmation-modal-confirm-button"
          >
            Confirm
          </button>
          <button
            onClick={onCancel}
            className="flex-1 border border-border text-foreground py-2 rounded-lg hover:bg-secondary transition-colors"
            data-testid="confirmation-modal-cancel-button"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}